import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('https://hs.learninghub.ind.in/api/auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        navigate('/admin/dashboard');
      } else {
        setError(data.message);
      }
    } catch (error) {
      setError('Server connection error');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = () => {
    alert('Forgot password functionality will be implemented');
  };

  const handleBackToHome = () => {
    navigate('/');
  };

  const styles = {
    loginContainer: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      padding: '20px',
    },
    loginCard: {
      background: '#fff',
      borderRadius: '20px',
      boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
      padding: '3rem',
      width: '100%',
      maxWidth: '450px',
      position: 'relative',
    },
    backButton: {
      position: 'absolute',
      top: '20px',
      left: '20px',
      background: 'transparent',
      border: 'none',
      color: '#667eea',
      fontSize: '1.5rem',
      cursor: 'pointer',
      transition: 'transform 0.2s ease',
    },
    logoContainer: {
      textAlign: 'center',
      marginBottom: '2rem',
    },
    logo: {
      fontSize: '3rem',
      marginBottom: '0.5rem',
    },
    logoText: {
      fontSize: '1.8rem',
      color: '#2c5aa0',
      fontWeight: 700,
      margin: 0,
    },
    loginTitle: {
      fontSize: '2rem',
      color: '#333',
      marginBottom: '0.5rem',
      textAlign: 'center',
      fontWeight: 600,
    },
    loginSubtitle: {
      fontSize: '1rem',
      color: '#666',
      marginBottom: '2rem',
      textAlign: 'center',
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
    },
    formGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    label: {
      fontSize: '0.95rem',
      color: '#333',
      fontWeight: 600,
    },
    input: {
      padding: '0.9rem 1rem',
      fontSize: '1rem',
      border: '2px solid #e0e0e0',
      borderRadius: '8px',
      outline: 'none',
      transition: 'all 0.3s ease',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    },
    passwordContainer: {
      position: 'relative',
    },
    passwordToggle: {
      position: 'absolute',
      right: '15px',
      top: '50%',
      transform: 'translateY(-50%)',
      background: 'transparent',
      border: 'none',
      cursor: 'pointer',
      fontSize: '1.2rem',
      color: '#666',
    },
    forgotPassword: {
      textAlign: 'right',
      marginTop: '-0.5rem',
    },
    forgotPasswordBtn: {
      background: 'transparent',
      border: 'none',
      color: '#667eea',
      fontSize: '0.9rem',
      cursor: 'pointer',
      fontWeight: 500,
      transition: 'color 0.3s ease',
    },
    loginButton: {
      padding: '1rem',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '1.1rem',
      fontWeight: 600,
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      marginTop: '1rem',
    },
    errorMessage: {
      color: '#dc3545',
      fontSize: '0.9rem',
      padding: '0.75rem',
      backgroundColor: '#f8d7da',
      border: '1px solid #f5c6cb',
      borderRadius: '5px',
      textAlign: 'center',
    },
    features: {
      marginTop: '2rem',
      padding: '1.5rem',
      background: '#f8f9fa',
      borderRadius: '10px',
    },
    featuresTitle: {
      fontSize: '0.9rem',
      color: '#666',
      marginBottom: '1rem',
      fontWeight: 600,
    },
    featuresList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    featureItem: {
      fontSize: '0.85rem',
      color: '#555',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
  };

  return (
    <div style={styles.loginContainer}>
      <div style={styles.loginCard}>
        <button 
          style={styles.backButton} 
          onClick={handleBackToHome}
          onMouseOver={(e) => e.target.style.transform = 'scale(1.2)'}
          onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
          title="Back to Home"
        >
          ← 
        </button>

        <div style={styles.logoContainer}>
          <div style={styles.logo}>🏨</div>
          <h1 style={styles.logoText}>HotelPro</h1>
        </div>

        <h2 style={styles.loginTitle}>Welcome Back</h2>
        <p style={styles.loginSubtitle}>Login to access your dashboard</p>

        <form style={styles.form} onSubmit={handleSubmit}>
          {error && <div style={styles.errorMessage}>{error}</div>}

          <div style={styles.formGroup}>
            <label style={styles.label} htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              required
              style={styles.input}
              onFocus={(e) => {
                e.target.style.borderColor = '#667eea';
                e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#e0e0e0';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label} htmlFor="password">Password</label>
            <div style={styles.passwordContainer}>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Enter your password"
                required
                style={{...styles.input, paddingRight: '45px'}}
                onFocus={(e) => {
                  e.target.style.borderColor = '#667eea';
                  e.target.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e0e0e0';
                  e.target.style.boxShadow = 'none';
                }}
              />
              <button
                type="button"
                style={styles.passwordToggle}
                onClick={() => setShowPassword(!showPassword)}
                onMouseOver={(e) => e.target.style.color = '#667eea'}
                onMouseOut={(e) => e.target.style.color = '#666'}
              >
                {showPassword ? '👁️' : '👁️‍🗨️'}
              </button>
            </div>
          </div>

          <div style={styles.forgotPassword}>
            <button
              type="button"
              style={styles.forgotPasswordBtn}
              onClick={handleForgotPassword}
              onMouseOver={(e) => {
                e.target.style.color = '#764ba2';
                e.target.style.textDecoration = 'underline';
              }}
              onMouseOut={(e) => {
                e.target.style.color = '#667eea';
                e.target.style.textDecoration = 'none';
              }}
            >
              Forgot Password?
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              ...styles.loginButton,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? 'not-allowed' : 'pointer'
            }}
            onMouseOver={(e) => {
              if (!loading) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 8px 20px rgba(102, 126, 234, 0.4)';
              }
            }}
            onMouseOut={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = 'none';
            }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={styles.features}>
          <p style={styles.featuresTitle}>Access Features:</p>
          <ul style={styles.featuresList}>
            <li style={styles.featureItem}>
              <span>✓</span> Manage hotel bookings
            </li>
            <li style={styles.featureItem}>
              <span>✓</span> Track guest information
            </li>
            <li style={styles.featureItem}>
              <span>✓</span> Monitor room availability
            </li>
            <li style={styles.featureItem}>
              <span>✓</span> Generate reports & analytics
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Login;